<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="vendor">Vendor</label>
                    <wj-combo-box
                        id="vendor"
                        [(ngModel)]="target.vendor"
                        name="vendor"
                        [itemsSource]="vendorOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isEditable]="false"
                        style="width: 100%"
                    ></wj-combo-box>
                </div>
            </div>
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="typeOfPipe">Type of Pipe</label>
                    <input type="text" class="form-control" id="typeOfPipe" [(ngModel)]="target.typeOfPipe" name="typeOfPipe" />
                </div>
            </div>
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="processForPipe">Process for Pipe</label>
                    <input type="text" class="form-control" id="processForPipe" [(ngModel)]="target.processForPipe" name="processForPipe" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="minimumBedding">Minimum Bedding</label>
                    <input type="text" class="form-control" id="minimumBedding" [(ngModel)]="target.minimumBedding" name="minimumBedding" />
                </div>
            </div>
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="minimumBeddingWidth">Minimum Bedding Width</label>
                    <input
                        type="text"
                        class="form-control"
                        id="minimumBeddingWidth"
                        [(ngModel)]="target.minimumBeddingWidth"
                        name="minimumBeddingWidth"
                    />
                </div>
            </div>
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="minimumAbovePipe">Minimum Above Pipe</label>
                    <input
                        type="text"
                        class="form-control"
                        id="minimumAbovePipe"
                        [(ngModel)]="target.minimumAbovePipe"
                        name="minimumAbovePipe"
                    />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="beddingMaterial">Bedding Material</label>
                    <input
                        type="text"
                        class="form-control"
                        id="beddingMaterial"
                        [(ngModel)]="target.beddingMaterial"
                        name="beddingMaterial"
                    />
                </div>
            </div>
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="beddingRequiredCompaction">Bedding Required Compaction</label>
                    <input
                        type="text"
                        class="form-control"
                        id="beddingRequiredCompaction"
                        [(ngModel)]="target.beddingRequiredCompaction"
                        name="beddingRequiredCompaction"
                    />
                </div>
            </div>
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="trenchZoneBackfillMaterial">Trench Zone Backfill Material</label>
                    <input
                        type="text"
                        class="form-control"
                        id="trenchZoneBackfillMaterial"
                        [(ngModel)]="target.trenchZoneBackfillMaterial"
                        name="trenchZoneBackfillMaterial"
                    />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="trenchZoneMaxLift">Trench Zone Max Lift</label>
                    <input
                        type="text"
                        class="form-control"
                        id="trenchZoneMaxLift"
                        [(ngModel)]="target.trenchZoneMaxLift"
                        name="trenchZoneMaxLift"
                    />
                </div>
            </div>
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="trenchZoneRequiredCompaction">Trench Zone Req. Compaction</label>
                    <input
                        type="text"
                        class="form-control"
                        id="trenchZoneRequiredCompaction"
                        [(ngModel)]="target.trenchZoneRequiredCompaction"
                        name="trenchZoneRequiredCompaction"
                    />
                </div>
            </div>
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="trenchZoneOptimumMoisture">Trench Zone Optimum Moisture</label>
                    <input
                        type="text"
                        class="form-control"
                        id="trenchZoneOptimumMoisture"
                        [(ngModel)]="target.trenchZoneOptimumMoisture"
                        name="trenchZoneOptimumMoisture"
                    />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 mb-3">
                <div class="form-group">
                    <label for="trenchZoneProduct">Trench Zone Product</label>
                    <input
                        type="text"
                        class="form-control"
                        id="trenchZoneProduct"
                        [(ngModel)]="target.trenchZoneProduct"
                        name="trenchZoneProduct"
                    />
                </div>
            </div>
            <div class="col-md-6 mb-3">
                <div class="form-group">
                    <label for="trenchZoneVendorId">Trench Zone Vendor</label>
                    <wj-combo-box
                        id="trenchZoneVendorId"
                        [(ngModel)]="target.trenchZoneVendorId"
                        name="trenchZoneVendorId"
                        [itemsSource]="trenchZoneVendorOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isEditable]="false"
                        style="width: 100%"
                    ></wj-combo-box>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 mb-3">
                <div class="form-group">
                    <label for="locationToBeInstalled">Location to be Installed</label>
                    <input
                        type="text"
                        class="form-control"
                        id="locationToBeInstalled"
                        [(ngModel)]="target.locationToBeInstalled"
                        name="locationToBeInstalled"
                    />
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="cancel()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="save()">Save</button>
    </div>
</form>
